<template>
  <div class="references-page">
    <section class="hero">
      <div class="container">
        <div class="hero-content">
          <h1>Client References</h1>
          <p>Hear directly from our clients about their experience working with us.</p>
        </div>
      </div>
    </section>

    <section class="references">
      <div class="container">
        <div class="reference-list">
          <div class="reference">
            <div class="reference-header">
              <img src="@/assets/images/client-logo1.png" alt="Client Logo" />
              <div class="reference-info">
                <h2>Edge Electric</h2>
                <p class="industry">Electrical Contracting | $45M Revenue</p>
              </div>
            </div>
            <div class="reference-content">
              <p>"Ascent Consulting helped us transform our operations from chaos to control. Their team became an extension of our leadership, guiding us through a complete overhaul of our processes and systems. The results were immediate and substantial."</p>
              <p class="highlight">Results: 15% increase in project profitability, 30% reduction in project delays</p>
              <p class="contact">Contact: Robert Davis, CEO - robert@edgeelectric.com</p>
            </div>
          </div>

          <div class="reference">
            <div class="reference-header">
              <img src="@/assets/images/client-logo2.png" alt="Client Logo" />
              <div class="reference-info">
                <h2>SunGrid Solar</h2>
                <p class="industry">Solar Installation | $32M Revenue</p>
              </div>
            </div>
            <div class="reference-content">
              <p>"When we decided to scale our business, we knew we needed expert guidance. Ascent Consulting provided the strategic framework and hands-on support that enabled us to expand into three new markets while maintaining our quality standards and improving our financial performance."</p>
              <p class="highlight">Results: Successfully expanded to 3 new markets, 22% increase in EBIT</p>
              <p class="contact">Contact: Maria Rodriguez, President - maria@sungird.com</p>
            </div>
          </div>

          <div class="reference">
            <div class="reference-header">
              <img src="@/assets/images/client-logo3.png" alt="Client Logo" />
              <div class="reference-info">
                <h2>Apex Mechanical</h2>
                <p class="industry">HVAC & Plumbing | $78M Revenue</p>
              </div>
            </div>
            <div class="reference-content">
              <p>"The Ascent team understood our challenges immediately. They didn't just provide recommendations—they rolled up their sleeves and helped us implement solutions. Their deep industry knowledge and commitment to our success made all the difference."</p>
              <p class="highlight">Results: 18% improvement in job costing accuracy, 25% reduction in administrative time</p>
              <p class="contact">Contact: James Wilson, COO - james@apexmech.com</p>
            </div>
          </div>

          <div class="reference">
            <div class="reference-header">
              <img src="@/assets/images/client-logo4.png" alt="Client Logo" />
              <div class="reference-info">
                <h2>Foundation Experts</h2>
                <p class="industry">Foundation & Concrete | $56M Revenue</p>
              </div>
            </div>
            <div class="reference-content">
              <p>"Working with Ascent Consulting was a game-changer for our company. They helped us implement a comprehensive ERP system and redesign our operational workflows. The increased visibility and control we gained have been transformative."</p>
              <p class="highlight">Results: 20% improvement in project margin, 40% reduction in change orders</p>
              <p class="contact">Contact: Patricia Thompson, CFO - patricia@foundationexperts.com</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="cta">
      <div class="container">
        <h2>Ready to Transform Your Business?</h2>
        <p>Contact us to discuss how we can help you achieve similar results.</p>
        <button class="cta-button">Schedule a Free Consultation</button>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ReferencesPage'
}
</script>

<style scoped>
.hero {
  background-image: url('@/assets/images/references-hero.jpg');
  background-size: cover;
  background-position: center;
  color: white;
  padding: 8rem 0;
  text-align: center;
  position: relative;
  width: 100%;
}

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 1;
}

.hero-content {
  position: relative;
  z-index: 2;
  max-width: 800px;
  margin: 0 auto;
  padding: 0 1rem;
}

.hero h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.hero p {
  font-size: 1.2rem;
}

.references {
  background-color: black;
  color: white;
  padding: 6rem 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.reference-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 3rem;
}

.reference {
  background-color: #111;
  border-radius: 8px;
  overflow: hidden;
  padding: 2rem;
}

.reference-header {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #333;
  flex-wrap: wrap;
}

.reference-header img {
  width: 60px;
  height: 60px;
  margin-right: 1rem;
}

.reference-info h2 {
  font-size: 1.5rem;
  margin-bottom: 0.25rem;
}

.industry {
  color: #aaa;
  font-size: 0.9rem;
}

.reference-content p {
  font-size: 1rem;
  line-height: 1.8;
  margin-bottom: 1.5rem;
}

.highlight {
  background-color: rgba(0, 123, 255, 0.1);
  padding: 1rem;
  border-left: 4px solid var(--primary-color);
  font-weight: bold;
}

.contact {
  font-style: italic;
  color: #aaa;
}

.cta {
  background-color: var(--bg-light);
  color: black;
  padding: 6rem 0;
  text-align: center;
}

.cta h2 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.cta p {
  font-size: 1.1rem;
  margin-bottom: 2rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 1rem;
}

.cta-button {
  background-color: var(--primary-color);
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 25px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.3s;
}

.cta-button:hover {
  background-color: var(--secondary-color);
}

@media (max-width: 768px) {
  .hero h1 {
    font-size: 2rem;
  }
}
</style>